import React from "react";
import { groupBy, map } from "lodash";
import { AiccSttOption } from "types/model/aiccLearningAssets";
import {
  STT_AVAILABLE_OPTIONS_TITLE,
  STT_CATALOGUE_UNAVAILABLE,
  STT_DEFAULT_FALLBACK_SUFFIX,
  STT_DEFAULT_PRIMARY_SUFFIX,
} from "./configs";
import styles from "./SttSetting.module.scss";
import learningAssetStyles from "../LearningAssets.module.scss";

interface Props {
  /** The catalogue, from the backend. This list used to be a constant in this folder — see `configs`. */
  options: AiccSttOption[];
  isError?: boolean;
}

/**
 * What the agent can actually build, grouped by mode.
 *
 * Each engine carries the fact a hardcoded list could not keep true: which SLOT it is the default for —
 * what a language that configures nothing runs.
 */
function AvailableOptions({ options, isError }: Props) {
  return (
    <div className={styles.availableOptions}>
      <div className={learningAssetStyles.sectionTitle}>{STT_AVAILABLE_OPTIONS_TITLE}</div>
      {/* Empty for a reason worth stating: without the catalogue there is nothing to choose from, and a
          blank panel reads as "this language has no engines". */}
      {isError && <div className={styles.optionDescription}>{STT_CATALOGUE_UNAVAILABLE}</div>}
      {map(groupBy(options, "mode"), (modeOptions, mode) => (
        <div key={mode} className={styles.modeGroup}>
          <div className={styles.modeLabel}>{mode}</div>
          {map(modeOptions, ({ key, displayName, description, isDefaultPrimary, isDefaultFallback }) => (
            <div key={key} className={styles.option}>
              <div className={styles.optionName}>
                {displayName}
                {isDefaultPrimary && <span className={styles.optionMark}>{` (${STT_DEFAULT_PRIMARY_SUFFIX})`}</span>}
                {isDefaultFallback && <span className={styles.optionMark}>{` (${STT_DEFAULT_FALLBACK_SUFFIX})`}</span>}
              </div>
              <div className={styles.optionDescription}>{description}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default AvailableOptions;
